import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { useAltDealStructureLink } from '../../baseDealActivity/baseDealContainer/hooks/useAltDealStructureLink';
import { InsightLink } from './ScenarioAiInsights.style';

export const ALT_DEAL_STRUCTURE_LABEL = 'Alt Deal Structure';

export const ScenarioAltDealStructureLink = () => {
    const theme = useInterstateTheme();
    const openAltDealStructures = useAltDealStructureLink();

    return (
        <InsightLink type="button" theme={theme} onClick={openAltDealStructures} data-testid="ai-card-alt-deal-structures-label">
            {ALT_DEAL_STRUCTURE_LABEL}
        </InsightLink>
    );
};
